import type { BondingPace } from 'generated/openapi';
import { type HTMLAttributes, memo } from 'react';

import { BONDING_PACE_MAP } from '@/features/profile/utils/bondingPace';
import { Badge } from '@/shared/components/ui/badge';
import { Card } from '@/shared/components/ui/card';

export interface ProfileDetailsVibeBondingPaceProps extends HTMLAttributes<HTMLDivElement> {
  bondingPace?: BondingPace;
}

export const ProfileDetailsVibeBondingPace = memo(
  function ProfileDetailsVibeVoiceChatParticipation({
    bondingPace,
    ...props
  }: ProfileDetailsVibeBondingPaceProps) {
    if (!bondingPace) return null;

    return (
      <Card variant="data" {...props}>
        <p className="text-sm leading-5 font-bold">Bonding pace</p>
        <Badge variant="display">
          {BONDING_PACE_MAP.get(bondingPace)?.icon}
          {BONDING_PACE_MAP.get(bondingPace)?.label}
        </Badge>
      </Card>
    );
  },
);
